import { CommonButton } from '@Components';
import React from 'react';
import { useDispatch } from 'react-redux';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import Message from 'semantic-ui-react/dist/commonjs/collections/Message';
import Transition from 'semantic-ui-react/dist/commonjs/modules/Transition';
import { AppDispatch, IErrorModalState } from '../../../../../store.type';
import { toggleErrorModalMsgAction } from '@Redux/actions/onboarding/new-onboarding-action';

export const ErrorModal: React.FC<{ errorModalState: IErrorModalState; onClose: () => void }> = (
  props
) => {
  const dispatch = useDispatch<AppDispatch>();
  const { errorModalState, onClose } = props;

  return (
    <Transition visible={errorModalState?.message?.length > 0} duration={300}>
      <Grid centered className="parent show-message">
        <Message className="commonMessage" floating compact id="common-message" error={true}>
          <Message.Content>
            <Grid centered className="messageParrent">
              <Grid.Row>
                <Grid.Column width={14} className={'popup-text'}>
                  <div>{errorModalState.message}</div>
                </Grid.Column>
                <Grid.Column width={14}>
                  <CommonButton
                    text="Got it"
                    margin="0 auto 20px"
                    width={125}
                    height={50}
                    id="common-message-submit"
                    onClick={() => {
                      dispatch(toggleErrorModalMsgAction({ showModal: false, message: '' }));
                      onClose();
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Message.Content>
        </Message>
      </Grid>
    </Transition>
  );
};
